import create from "zustand";

// Tracks opponents this client is expecting a *club* game challenge_request_check
// from, so it can auto-accept silently (no modal). ONLY the accepter marks — when
// they tap Accept on a club challenge card, they mark the creator, then the creator
// fires the game (challengeGame) and this client auto-accepts the incoming check.
// Single-directional by design: the creator never marks anyone, so there is no
// mutual auto-accept. Entries expire after a short TTL and clear on use.
const EXPECTED_TTL_MS = 2 * 60 * 1000; // 2 minutes

type State = {
  // opponent userId (as string) -> timestamp (ms) it was marked expected
  expectedOpponents: Record<string, number>;
  markExpected: (userId: string | number) => void;
  isExpected: (userId: string | number) => boolean;
  clearExpected: (userId: string | number) => void;
};

const useClubChallengeStore = create<State>((set, get) => ({
  expectedOpponents: {},
  markExpected: (userId) => {
    const key = String(userId);
    if (!key || key === "undefined" || key === "null") return;
    set((s) => ({ expectedOpponents: { ...s.expectedOpponents, [key]: Date.now() } }));
  },
  isExpected: (userId) => {
    const ts = get().expectedOpponents[String(userId)];
    return !!ts && Date.now() - ts <= EXPECTED_TTL_MS;
  },
  clearExpected: (userId) => {
    const key = String(userId);
    set((s) => {
      if (!(key in s.expectedOpponents)) return s;
      const next = { ...s.expectedOpponents };
      delete next[key];
      return { expectedOpponents: next };
    });
  },
}));

export default useClubChallengeStore;
